// PHONE NUMBER NORMALIZATION CONSTANTS

export const DEFAULT_COUNTRY = 'US';

// COUNTRIES THAT USE NATIONAL FORMAT FOR DISPLAY (ALL OTHERS USE INTERNATIONAL)
export const NATIONAL_FORMAT_COUNTRIES = ['US', 'CA'];

// PATTERNS THAT INDICATE EXTENSIONS (REJECT THESE)
export const EXTENSION_PATTERNS = /ext|x|#/i;
